    
<template>
  <common-page-layout>   

  </common-page-layout>
</template>


<script>
  import {mapGetters} from "vuex";
 
  export default {   
    computed: {
      ...mapGetters(["combinedremedials"])
    }
  };
</script>
 


// WEBPACK FOOTER //
// src/components/admin/customerremedials/AdminCustomersRemedialsDeclined.vue